import { motion } from "framer-motion";
import { Instagram, ArrowUpRight } from "lucide-react";
import { SITE } from "@/data/site";
import { PRODUCTS } from "@/data/products";

// TikTok icon (lucide doesn't include it cleanly across versions)
const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V9.01a8.16 8.16 0 0 0 4.77 1.52V7.08a4.85 4.85 0 0 1-1.84-.39Z"
      stroke="currentColor" strokeWidth="0.6" fill="currentColor"/>
  </svg>
);

export const SocialFeed = () => {
  const ig = PRODUCTS.slice(0, 6);

  return (
    <section id="sosyal" className="py-24 lg:py-32 cream-grain">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Instagram */}
          <div>
            <span className="eyebrow flex items-center gap-3">
              <Instagram size={14} className="gold-text" /> Instagram
            </span>
            <h2 className="font-display text-3xl lg:text-4xl mt-3 text-[hsl(var(--nl-anthracite))]">
              Günlük dünyamız <em className="not-italic font-serif italic gold-text">@novalandaksesuar</em>
            </h2>
            <p className="text-sm text-[hsl(var(--muted-foreground))] mt-3 max-w-md">
              Yeni gelenler, kombin önerileri ve sahne arkası anlarımız için bizi takip edin.
            </p>

            <div className="mt-8 grid grid-cols-3 gap-2">
              {ig.map((p, i) => (
                <motion.a
                  key={p.id}
                  data-testid={`ig-tile-${i}`}
                  href={SITE.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  initial={{ opacity: 0, scale: 0.95 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.04 * i }}
                  className="group relative aspect-square overflow-hidden bg-[hsl(var(--nl-beige))]"
                >
                  <img src={p.image} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-[hsl(var(--nl-anthracite)/0.5)] opacity-0 group-hover:opacity-100 transition-opacity duration-300 grid place-items-center">
                    <Instagram className="text-white" size={22} />
                  </div>
                </motion.a>
              ))}
            </div>

            <a
              data-testid="ig-follow"
              href={SITE.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ghost-gold mt-8"
            >
              Instagram&apos;da Takip Et <ArrowUpRight size={12} />
            </a>
          </div>

          {/* TikTok */}
          <div className="relative">
            <span className="eyebrow flex items-center gap-3">
              <TikTokIcon size={14} /> TikTok
            </span>
            <h2 className="font-display text-3xl lg:text-4xl mt-3 text-[hsl(var(--nl-anthracite))]">
              Hareketli sahnemiz <em className="not-italic font-serif italic gold-text">@novaland.aksesuar</em>
            </h2>
            <p className="text-sm text-[hsl(var(--muted-foreground))] mt-3 max-w-md">
              Trendler, kombin videoları ve yeni koleksiyon tanıtımları TikTok&apos;ta.
            </p>

            <div className="mt-8 relative bg-[hsl(var(--nl-anthracite))] text-[hsl(var(--nl-cream))] p-8 lg:p-10 overflow-hidden">
              <div className="absolute -right-12 -bottom-12 w-56 h-56 rounded-full bg-[hsl(var(--nl-champagne)/0.2)] blur-2xl" />
              <div className="relative z-10">
                <TikTokIcon size={42} />
                <p className="font-serif italic text-2xl mt-6 leading-snug">
                  &ldquo;Her video, hikâyemizin bir karesi.&rdquo;
                </p>
                <p className="text-sm text-[hsl(var(--nl-cream))]/70 mt-4 max-w-sm">
                  Yeni koleksiyonların ilk tanıtımları, stil önerileri ve müşteri paylaşımları için bizi TikTok&apos;tan takip etmeyi unutmayın.
                </p>
                <a
                  data-testid="tiktok-follow"
                  href={SITE.social.tiktok}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 mt-7 px-5 py-3 bg-[hsl(var(--nl-cream))] text-[hsl(var(--nl-anthracite))] text-xs uppercase tracking-[0.18em] font-medium hover:bg-[hsl(var(--nl-champagne))] transition-colors"
                >
                  TikTok&apos;ta Takip Et <ArrowUpRight size={14} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialFeed;
